/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long should my password be?`)
};

const es_pw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué tan larga debe ser mi contraseña?`)
};

const de_pw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lang sollte mein Passwort sein?`)
};

const nl_pw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe lang moet mijn wachtwoord zijn?`)
};

const fr_pw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle longueur mon mot de passe devrait-il avoir?`)
};

const it_pw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto lunga dovrebbe essere la mia password?`)
};

const pt_br2_pw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual deve ser o comprimento da minha senha?`)
};

const pt_pw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual deve ser o comprimento da minha senha?`)
};

const ja_pw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードはどのくらい長くする必要がありますか?`)
};

const zh_pw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的密码应该多长？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_faq3_q", locale)
	if (locale === "en") return en_pw_faq3_q(inputs)
	if (locale === "es") return es_pw_faq3_q(inputs)
	if (locale === "de") return de_pw_faq3_q(inputs)
	if (locale === "nl") return nl_pw_faq3_q(inputs)
	if (locale === "fr") return fr_pw_faq3_q(inputs)
	if (locale === "it") return it_pw_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_pw_faq3_q(inputs)
	if (locale === "pt") return pt_pw_faq3_q(inputs)
	if (locale === "ja") return ja_pw_faq3_q(inputs)
	return zh_pw_faq3_q(inputs)
};